const WithrawalIcon = () => {
    return <img src={process.env.PUBLIC_URL + '/style/img/btn-icon/ico-withrawal-popup.png'} />;
};

export default WithrawalIcon;
